import UL from './UL'
export default UL



// WEBPACK FOOTER //
// ./src/atoms/UL/index.js